import { Types } from "./types";

const initialState = {
  dataGoldGroup: {
    rows: [],
  },
  dataReferenceTab: {
    rows: [],
  },
  dataUSDReferenceTab: {
    rows: [],
  },
  dataReferenceItem: {
    rows: [],
  },
  dataUSDReferenceItem: {
    rows: [],
  },
  dataGoldOfficial: {
    rows: [],
    paging: {},
  },
  dataUSDOfficial: {
    rows: [],
    paging: {},
  },
  dataGoldPrice: {
    rows: [],
    paging: {},
  },
  dataGoldHanaPrice: {
    rows: [],
    paging: {},
  },
  dataHistoryGoldHana: {
    rows: [],
    paging: {},
  },
  dataGold: {
    rows: [],
    paging: {},
  },
  dataAllGoldPrice: {
    rows: [],
    paging: {},
  },
  dataHistoryCrawlPrice: {
    rows: [],
    paging: {},
  },
  dataHistoryCrawlUSDPrice: {
    rows: [],
    paging: {},
  },
};
const reducer = (state = initialState, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case Types.SAVE_LIST_GOLD_PRICE:
      return {
        ...newState,
        dataGoldPrice: action.payload,
      };
    case Types.SAVE_ALL_GOLD_PRICE:
      return {
        ...newState,
        dataAllGoldPrice: action.payload,
      };
    case Types.SAVE_LIST_GOLD:
      return {
        ...newState,
        dataGold: action.payload,
      };
    case Types.SAVE_GOLD_GROUP:
      return {
        ...newState,
        dataGoldGroup: action.payload,
      };
    case Types.SAVE_REFERENCE_TAB:
      return {
        ...newState,
        dataReferenceTab: action.payload,
      };
    case Types.SAVE_USD_REFERENCE_TAB:
      return {
        ...newState,
        dataUSDReferenceTab: action.payload,
      };
    case Types.SAVE_REFERENCE_ITEM:
      return {
        ...newState,
        dataReferenceItem: action.payload,
      };
    case Types.SAVE_USD_REFERENCE_ITEM:
      return {
        ...newState,
        dataUSDReferenceItem: action.payload,
      };
    case Types.SAVE_GOLD_OFFICIAL:
      return {
        ...newState,
        dataGoldOfficial: action.payload,
      };
    case Types.SAVE_USD_OFFICIAL:
      return {
        ...newState,
        dataUSDOfficial: action.payload,
      };
    case Types.SAVE_HISTORY_CRAWL_GOLD:
      return {
        ...newState,
        dataHistoryCrawlPrice: action.payload,
      };
    case Types.SAVE_HISTORY_CRAWL_USD:
      return {
        ...newState,
        dataHistoryCrawlUSDPrice: action.payload,
      };
    case Types.SAVE_GOLD_HANA_PRICE:
      return {
        ...newState,
        dataGoldHanaPrice: action.payload,
      };
    case Types.SAVE_HISTORY_GOLD_HANA:
      return {
        ...newState,
        dataHistoryGoldHana: action.payload,
      };
    default:
      return { ...newState };
  }
};
export default reducer;
